define('commons/global-help',['jquery', 'introjs'], function($, introJs) {
    /**
     * Creates a cute tiny widget used to launch an awesome show describing what does what on the screen. 
     * Also called step-by-step guide.
     * @param jsonConfig An array representing the steps, e.g. : 
     * jsonConfig : [
     *     {
     *       element: 'div.filter-container',
     *       intro: "This is a filter."
     *     },
     *     {
     *       element: 'div#data-table-wrapper',
     *       intro: "Ok, wasn't that fun?",
     *       position: 'right'
     *     }
     *   ]
     * @param onClickCheck Check some preconditions, display messages if needed and so on. If this function returns false the introjs won't be launched.
     */
    var GlobalHelp = function( jsonConfig, onClickCheck) {
        this.introJs = introJs();
        this.onClickCheck = onClickCheck;
        this._initIntroJs( jsonConfig );
        this._initHelpButton();
    };
    
    GlobalHelp.prototype._initIntroJs = function( jsonConfig ){
        this.introJs.setOptions({
            steps: jsonConfig,
            tooltipClass : 'custom-global-help-tooltip'
        });
    };
    
    GlobalHelp.prototype._initHelpButton = function(){
        // Search the help button
        var $helpBtn = $('#global-help');
        // show it
        $helpBtn.removeClass('hidden');
        // launch the guided tour on click
        $helpBtn.on('click', $.proxy(function(event){
            event.preventDefault();
            // Run the check if provided
            if(this.onClickCheck && !this.onClickCheck()){
                return;
            }
            this.introJs.start();
        }, this));
    };
    
    return GlobalHelp;
});
